// Modules
import { useAuth } from 'presentation/app/hooks/useAuth';
import { ProtectedForgetPasswordPage } from 'presentation/app/modules/Authentication/authentication-password-reset/send-password-reset-code/pages/ProtectedForgetPasswordPage';
import { ProtectedPageSetNewPassword } from 'presentation/app/modules/Authentication/authentication-password-reset/set-new-password/pages/ProtectedPageSetNewPassword';
import { ProtectedVerifyCodePage } from 'presentation/app/modules/Authentication/authentication-password-reset/verify-code/pages/ProtectedVerifyCodePage';
import { Login } from 'presentation/app/modules/Authentication/pages/login';
import { GestorPersonImpersonation } from 'presentation/app/modules/Impersonate/pages/gestor-person-impersonation';
import { OrganizacaoPersonImpersonation } from 'presentation/app/modules/Impersonate/pages/organizacao-person-impersonation';
import { Navigate } from 'react-router-dom';

const ProtectedLogin = () => {
  const { currentUser } = useAuth();

  if (currentUser) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Login />;
};

const publicRoutes = [
  { path: '/login', component: <ProtectedLogin /> },
  {
    path: '/impersonate/gestor/:personId',
    component: <GestorPersonImpersonation />,
  },
  {
    path: '/impersonate/organizacao/:personId',
    component: <OrganizacaoPersonImpersonation />,
  },

  {
    path: '/redefinir-senha',
    component: <ProtectedForgetPasswordPage />,
  },
  {
    path: '/redefinir-senha/codigo-verificacao',
    component: <ProtectedVerifyCodePage />,
  },
  {
    path: '/redefinir-senha/nova-senha',
    component: <ProtectedPageSetNewPassword />,
  },
];

export { publicRoutes };
